var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = '${{amount}}';
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};





function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) {
    elementToFocus.focus();
    setTimeout(function() {
      elementToFocus.blur();
    }, 100);
  }
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const allTabs = document.querySelectorAll('.menu-drawer__navigation ul > details');
    const noGenderLocalization = document.querySelectorAll('.localization-test')[0];

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (summaryElement.parentNode.classList.contains('menu-tab')) {
      for (let i = 0; i < allTabs.length; i++) {
        allTabs[i].removeAttribute('open');
      }
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      let animationTime = 0;

      setTimeout(() => {
        // if not gender selected remove class
        if(document.body.classList.contains('gender-generic')) {
          document.body.classList.remove('gender-generic');
          noGenderLocalization.classList.remove('localization-test');
        }

        document.body.setAttribute('menu-child-open', true);
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, animationTime);
    }
  }

  openMenuDrawer(summaryElement) {
    document.body.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    
    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
     // details.removeAttribute('open');
    // details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 300) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  connectedCallback() { }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    }); 

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    document.body.classList.add('menu-open');
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
    document.body.classList.remove('menu-open');
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
      });
    } else {
      this.addEventListener('click', (event) => {
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;

    Antonioli.sliderIndex = 0;

    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();

  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('preorder-product');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }
  
  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.algolia = new AlgoliaUtils();
    this.recommendProducts = [];
    this.recommendQueryId = '';
  }

  connectedCallback() {
    const handleIntersection = async (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      
      const products = await this.fetchProducts();
      this.render(products);
      this.setRecommendClickListeners();
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }

  async fetchProducts() {
    const result = await this.algolia.getReccomendations(this.dataset.variant);
    this.recommendQueryId = result?.queryID || '';
    const hits = result?.hits ?? [];
    const set = new Set();
    set.add(this.dataset.handle);

    this.recommendProducts = hits.filter((item) => {
      const uniqueKey = item?.handle;
      if (!uniqueKey || set.has(uniqueKey)) return false;
      set.add(uniqueKey);
      return true;
    }).slice(0, 20);

    return this.recommendProducts;
  }

  async render(products) {
    const handles = products.map(product => product.handle);
    const request = "&q=" + handles.join(",");

    const response = await fetch(`/search?view=product-reccomendations${request}`);
    const result = await response.text();

    const html = new DOMParser().parseFromString(result, 'text/html')?.querySelector('[data-result]')?.innerHTML;
    this.querySelector('[data-container]').innerHTML = html;

    const slides = this.querySelectorAll('.swiper-slide');
    for (const [index, product] of products.entries()) {
      const slide = slides[index];
      if (!slide) continue;
      slide.dataset.algoliaObjectId = product.objectID;
      slide.dataset.algoliaProductId = product.id || product.objectID;
      slide.dataset.algoliaPosition = product.__position ?? (index + 1);
      slide.dataset.algoliaQueryId = this.recommendQueryId;
      slide.dataset.algoliaIndex = this.algolia.getIndexName();
    }
  }

  setRecommendClickListeners() {
    this.addEventListener('click', (event) => {
      const slide = event.target.closest('.swiper-slide[data-algolia-object-id]');
      if (!slide) return;

      AlgoliaInsights.trackRecommendClick({
        queryID: slide.dataset.algoliaQueryId,
        objectID: slide.dataset.algoliaObjectId,
        productId: slide.dataset.algoliaProductId,
        position: Number(slide.dataset.algoliaPosition),
        index: slide.dataset.algoliaIndex || this.algolia.getIndexName(),
      });
    });
  }
}

customElements.define('product-recommendations', ProductRecommendations);


class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    const inputLanguage = this.querySelector('input[name="language_code"]');
    const inputCountry = this.querySelector('input[name="country_code"]');
    const form = this.querySelector('form');
    this.openLang = document.querySelector('.open-language');
    this.openCountries = document.querySelector('.open-countries');
    this.openSpecificTab = false;
    this.elements = { inputLanguage, inputCountry, form };
    form.addEventListener('submit', (event) => {
      AntonioliCookieFunctions.createCookie('forceLocalization', true);
      AntonioliCookieFunctions.deleteCookie('currentMarket');
    })
    this.init();
    this.initSidebarClickListeners();

  }


  initSidebarClickListeners() {
    const openSidebarItems = document.querySelectorAll('.open-sidebar li');
    openSidebarItems.forEach(item => {
        item.addEventListener('click', () => {
            const dataOpen = item.getAttribute('sidebar-open');
            if (dataOpen === 'shipping-language') {
                this.openLang.click();
            } else if (dataOpen === 'shipping-countries') {
                this.openCountries.click();
            }
        });
    });
  }

  init() {
    const toggleVisibility = (parent, selectorToShow, selectorToHide) => {
      this.openLang.classList.remove('opened');
      this.openCountries.classList.remove('opened');
      parent.classList.add('opened');
      document.querySelector(selectorToShow).classList.remove('tw-hidden');
      document.querySelector(selectorToHide).classList.add('tw-hidden');
    };
  
    const handleClick = (parent,showSelector, hideSelector) => {
      return () => {
        toggleVisibility(parent, showSelector, hideSelector);
      };
    };  

    this.openLang.addEventListener('click', handleClick(this.openLang, '#LanguageList', '#CountryList'));
    this.openCountries.addEventListener('click', handleClick(this.openCountries,'#CountryList', '#LanguageList'));
    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  onItemClick(event) {
    event.preventDefault();
    const { target } = event;
    const type = target.getAttribute('type');
    const value = target.dataset.value;

    // rimuovo la classe tw-h3-med da tutti gli elementi non cliccati
    this.querySelectorAll('a').forEach(item => {
        if (item !== target) {
            item.classList.remove('tw-h3-med');
            item.classList.add('tw-h3-reg');
        }
    });

    target.classList.add('tw-h3-med');
    target.classList.remove('tw-h3-reg');

    if (type === 'language') {
      this.elements.inputLanguage.value = value;
    } else if (type === 'country') {
      this.elements.inputCountry.value = value;
    }
    
  
  }
}

if (!customElements.get('localization-form')) {
  customElements.define('localization-form', LocalizationForm);
}

class InputFilter extends HTMLElement {
  constructor() {
    super();
    this.filterInput = this.querySelector('input');
    this.listSelector = this.getAttribute('list-selector');
    this.itemSelector = this.getAttribute('item-selector');

    if (!this.filterInput || !this.listSelector || !this.itemSelector) {
      console.error('Missing required attributes: filter input, list selector, or item selector');
      return;
    }

    this.init();
  }

  init() {
    const itemList = [...document.querySelector(this.listSelector).querySelectorAll(this.itemSelector)];

    this.filterInput.addEventListener('input', () => {
      const filterValue = this.filterInput.value.trim().toLowerCase();

      itemList.forEach(item => {
        const itemText = item.textContent.trim().toLowerCase();
        const isVisible = itemText.includes(filterValue);
        item.style.display = isVisible ? 'block' : 'none';
      });
    });
  }
}

customElements.define('input-filter', InputFilter);


document.addEventListener('DOMContentLoaded', function(){
  var live_url = window.location.href;
  var result = live_url.includes('form_type=customer');
  var input_val = document.querySelector('input[type="email"]').value.length;


  if(result && input_val != 0){
    const add_ele_inline = document.createElement("small");
    const customElementErrorField = document.querySelector('error-block #error-message');
    add_ele_inline.innerText = document.querySelector('input[name="contact[email]"]').getAttribute('data-message');

    customElementErrorField.append(add_ele_inline);

    const add_ele_banner = document.createElement("h3");
    add_ele_banner.innerText = document.querySelector('input[name="contact[email]"]').getAttribute('data-message');
    add_ele_banner.classList.add('newsletter_already_subscribe-banner','newsletter-form__message','form__message');
    document.querySelector('.newsletter-footer_cta').parentElement.append(add_ele_banner);
  }

  if(window.screen.width > 759){
    document.getElementById('MainContent').classList.add('tw-relative');
  }
})

document.addEventListener('DOMContentLoaded', function () {
  if (window.screen.width >= 1024) return;

  /** @type {{ block: HTMLElement, container: HTMLElement, offset: number }[]} */
  const stickyConfigs = [];

  document.querySelectorAll('.banner-sticky-container').forEach((container) => {
    Array.from(container.children).forEach((block) => {
      if (!Array.from(block.classList).includes('sticky-cta')) return;

      const containerRect = container.getBoundingClientRect();
      const header = document.querySelector('sticky-header');
      const headerOffset = header ? header.clientHeight : 0;
      const offset = containerRect.height / 2 + containerRect.top - headerOffset;

      stickyConfigs.push({ block, container, offset });
    });
  });

  if (!stickyConfigs.length) return;

  let scrollScheduled = false;

  const updateStickyBlocks = () => {
    const scrollY = window.scrollY;

    stickyConfigs.forEach(({ block, container, offset }) => {
      if (scrollY > offset) {
        block.style.position = 'sticky';
        block.style.bottom = '80%';
        block.style.top = 'unset';
        block.style.padding = '0 1.6rem';
        container.style.margin = '0 0 -7rem 0';
      } else {
        block.style.position = 'absolute';
        block.style.top = '50%';
        block.style.padding = '1rem 1.6rem 2.8rem 1.6rem';
        container.style.margin = 'unset';
      }
    });
  };

  updateStickyBlocks();

  window.addEventListener(
    'scroll',
    () => {
      if (scrollScheduled) return;
      scrollScheduled = true;
      requestAnimationFrame(() => {
        scrollScheduled = false;
        updateStickyBlocks();
      });
    },
    { passive: true }
  );
});

document.addEventListener("DOMContentLoaded", () => {
    const redirectParam = localStorage.getItem('redirect_param');
    if (redirectParam) AccountParameterHandler.reloadWithParam(redirectParam);

    if (!AntonioliCookieFunctions.checkCookieExists('currentMarket')) {
        AntonioliCookieFunctions.createCookie('currentMarket', Shopify.routes.root, 10);
    }

    const root = `${window.location.origin}${Shopify.routes.root}`;
    const genderCollection = localStorage.getItem('active_gender') === 'woman' ? 'collections/woman' : 'collections/man';
    document.querySelector('.header__heading-link').setAttribute('href', `${root}${genderCollection}`);

    const lastPlpGender = sessionStorage.getItem('last_plp_gender');
    const realGender = sessionStorage.getItem('real_gender');
    const isUnisex = realGender === 'unisex';

    if (!lastPlpGender) return;

    if (!isUnisex) return;

    ['[data-pdp-gender]', '[data-related-designer]', '[data-related-category]'].forEach(selector => {
        document.querySelectorAll(selector).forEach(el => {
            el.setAttribute('href', el.getAttribute('href').replace('man', lastPlpGender));
        });
    });
});

if (!customElements.get('counter-collections')) {
  class CounterCollections extends HTMLElement {
    constructor() {
      super();
      this.min = parseInt(this.dataset.min, 10);
      this.max = parseInt(this.dataset.max, 10);
      this.counterDiv = this.querySelector('.round-number');
      this.today = new Date(this.dataset.today);
      this.counterDiv.innerHTML = this.dailyRandom();
    }
    hash(seed) {
      let hash = 0;
      for (let i = 0; i < seed.length; i++) {
        hash = (hash << 5) - hash + seed.charCodeAt(i);
        hash |= 0; // Converte in intero a 32 bit
      }
      return Math.abs(hash);
    }
    dailyRandom() {
      const startOfYear = new Date(this.today.getFullYear(), 0, 1);
      const dayOfYear = Math.floor((this.today - startOfYear) / (1000 * 60 * 60 * 24)) + 1;
      const seed = `${this.today.getFullYear()}-${dayOfYear}`;
      const hashedValue = this.hash(seed);
      const range = this.max - this.min + 7;
      const pseudoRandom = (hashedValue % range) + this.min;
      return pseudoRandom;
    }
  }
  customElements.define('counter-collections', CounterCollections);
}

if (!customElements.get('text-above')) {
  class TextAbove extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const parentSection = this.closest('section');
      if (!parentSection) return;

      const sameSectionElements = Array.from(
        document.querySelectorAll('text-above')
      ).filter(element => element.closest('section') === parentSection);

      if (sameSectionElements.length <= 1) return;

      // Funzione per calcolare altezza + margini dai data-attribute
      const calculateMaxHeightWithMargins = element => {
        if (!element) return 0;

        // Altezza visibile
        const visibleHeight = element.offsetHeight;

        // Margini presi dai data-attribute
        const marginTop = parseFloat(element.getAttribute('data-margin-top')) || 0;
        const marginBottom = parseFloat(element.getAttribute('data-margin-bottom')) || 0;

        // Altezza totale: visibile + margini
        return visibleHeight + marginTop + marginBottom;
      };

      // Calcola l'altezza massima includendo i margini
      const maxHeight = Math.max(
        ...sameSectionElements.map(element => calculateMaxHeightWithMargins(element))
      );

      // Imposta l'altezza massima ai singoli elementi
      sameSectionElements.forEach(element => {
        const marginTop = parseFloat(element.getAttribute('data-margin-top')) || 0;
        const marginBottom = parseFloat(element.getAttribute('data-margin-bottom')) || 0;

        // Imposta l'altezza come maxHeight meno i margini
        element.style.height = `${maxHeight - marginTop - marginBottom}px`;
      });
    }
  }

  customElements.define('text-above', TextAbove);
}

class CustomDialog extends HTMLElement {
  constructor() {
    
    super();
    this.handleButtonClick = this.handleButtonClick.bind(this);
    this.handleDialogClose = this.handleDialogClose.bind(this);
  }

  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    const dataTargetValue = this.getAttribute('data-target'); 
    this.buttons = document.querySelectorAll(`button[data-target="${dataTargetValue}"]`);
    this.closeButton = this.querySelectorAll(`button[data-dialog="close"]`);

    if (!this.dialog) 
      return
    

    this.buttons.forEach(button => {
      button.addEventListener('click', this.handleButtonClick);
    });

    this.closeButton.forEach(button => {
      button.addEventListener('click',() => {
        if (this.dialog.querySelector('.dialog')) {
          this.dialog.querySelector('.dialog')?.classList.add('fade-in');
        } else {
          this.dialog.classList.remove('fade-in');
        }
        this.dialog.close();
      });
    });

    this.dialog.addEventListener('click', this.handleDialogClose);

  }

  disconnectedCallback() {
    if (this.button) {
      this.button.removeEventListener('click', this.handleButtonClick);
    }
    if (this.dialog) {
      this.dialog.removeEventListener('close', this.handleDialogClose);
    }
  }

  handleButtonClick() {
    if (!this.dialog) return

    const dialogToFadeIn = this.dialog.querySelector('.dialog') || this.dialog
    dialogToFadeIn.classList.add('fade-in');
    this.dialog.showModal();

  }

  handleDialogClose(event) {
    publish(PUB_SUB_EVENTS.popupClose)
    if (!this.dialog) return
    const rect = this.dialog.getBoundingClientRect();
    const isInDialog =
      event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom;

    if (isInDialog) return
    setTimeout(() =>{
        this.dialog.close();
    }, 400);

    if (this.dialog.querySelector('.dialog')) {
      this.dialog.querySelector('.dialog')?.classList.add('fade-in');
    } else {
      this.dialog.classList.remove('fade-in');
    }
  }

}
customElements.define('custom-dialog', CustomDialog);
class CountryBar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.checkCountry();
  }

  async checkCountry() {
    const isForced = AntonioliCookieFunctions.getCookieValue('forceLocalization') || sessionStorage.getItem('forceLocalization');
    if (isForced) return
    if (!this.dataset.userCountry) return

    const url = '/browsing_context_suggestions.json';
    const response = await fetch(url);
    const result = await response.json();

    const navigationCountry = result.detected_values.country
    if (navigationCountry.handle === this.dataset.userCountry) return

    this.setTimer();
    this.setListeners(navigationCountry);

    this.removeAttribute('hidden');

    this.querySelector('[data-country]').innerHTML = navigationCountry.name + ' (' + navigationCountry.handle + ')';
    this.querySelector('[data-stay-on]').innerHTML = navigationCountry.handle;
  }

  setListeners(navigationCountry) {
    this.querySelector('[data-localization-change]').addEventListener('click', () => {
      this.querySelector('[data-localization-select]').value = this.dataset.userCountry;
      AntonioliCookieFunctions.createCookie('forceLocalization', true);
      this.querySelector('form').submit();
    });

    this.querySelector('[data-localization-continue]').addEventListener('click', () => {
      this.querySelector('[data-localization-select]').value = navigationCountry.handle;
      AntonioliCookieFunctions.createCookie('forceLocalization', true);
      this.querySelector('form').submit();
    });

    this.querySelector('[data-localization-sidebar]').addEventListener('click', () => {
      document.querySelector('.sidebar-content .open-countries')?.click()
    });
  }

  setTimer() {
    const expireSecond = this.dataset.expire || 0;
    if (expireSecond == 0) return;

    setTimeout(() => {
      this.toggleAttribute('hidden', true);
      sessionStorage.setItem('forceLocalization', true);
    }, expireSecond * 1000);
  }
}

customElements.define('country-bar', CountryBar);

if (Antonioli.settings.template === 'collection' && !['woman', 'man'].includes(Antonioli.settings.templateSuffix)) {
  const key = 'bfcache-' + window.location.pathname;
  let ignoreScroll = false;

  document.addEventListener('click', (e) => {
    const link = e.target;
    if (!link) return;

    ignoreScroll = link.classList.contains('pagination__item');
  });

  window.addEventListener('pageshow', function () {
    const item = JSON.parse(localStorage.getItem(key));
    const currentScroll = parseInt(item.scroll || item, 10);
    const time = item.time || 0;

    if (currentScroll && Date.now() - time < 3000) 
      window.scrollTo(0, parseInt(currentScroll, 10));
    
    localStorage.removeItem(key);
  });

  window.addEventListener('pagehide', () => {
    if (!ignoreScroll) {
      const scrollData = {
        scroll: window.scrollY,
        time: Date.now()
      };
      localStorage.setItem(key, JSON.stringify(scrollData));
    }
  });
}

class MenuToggle extends HTMLElement {
  constructor() { super() }

  connectedCallback() {
    this.slider = this.querySelector('[data-slider]');

    const input = this.querySelector('input[type="radio"]:checked');
    if (input) {
      this.updateSliderPosition(input);
      this.toggleMenu(input.value);
    }
    
    this.querySelectorAll('input[type="radio"]').forEach(input => {
      input.addEventListener('change', () => {
        this.toggleMenu(input.value);
        this.updateSliderPosition(input);
      });
    });
  }

  toggleMenu(activeValue) {
    this.querySelectorAll('[data-value]').forEach(menu => {
      menu.toggleAttribute('active', menu.dataset.value === activeValue);
    });
  }

  updateSliderPosition(input) {
    if (!this.slider || !input) return;

    const activeLabel = input.closest('label');

    const labelRect = activeLabel.getBoundingClientRect();
    const containerRect = this.getBoundingClientRect();

    const newLeft = labelRect.left - containerRect.left;
    const newWidth = labelRect.width;

    this.slider.style.width = `${newWidth}px`;
    this.slider.style.transform = `translateX(${newLeft}px)`;
  }
}

customElements.define('menu-toggle', MenuToggle);

class CookiebotTrigger extends HTMLElement {
  constructor() { super(); }
  
  connectedCallback() {
    this.addEventListener('click', () => {
      Cookiebot && Cookiebot.show();
    });
  }

}
customElements.define('cookiebot-trigger', CookiebotTrigger);

class CollectionGrid extends HTMLElement {

  /**
   * Last loaded page index (Shopify `page` query, or legacy `pagination` param).
   * A missing `page` param is page 1.
   * @returns {number}
   */
  get pagination() {
    const url = new URL(window.location.href);
    const page = parseInt(url.searchParams.get("page"), 10);
    if (!Number.isNaN(page) && page > 0) return page;
    const legacy = parseInt(url.searchParams.get("pagination"), 10);
    if (!Number.isNaN(legacy) && legacy > 0) return legacy;
    return 1;
  }

  /**
   * Writes the active collection page onto a URL.
   * Page 1 stays unparameterized so the address is not rewritten to `?page=1`.
   * The legacy `pagination` param is always removed.
   * @param {URL} url
   * @param {number|string} page
   * @returns {URL}
   */
  applyPageParam(url, page) {
    const pageNum = parseInt(page, 10);
    url.searchParams.delete("pagination");
    if (!Number.isNaN(pageNum) && pageNum > 1) {
      url.searchParams.set("page", String(pageNum));
    } else {
      url.searchParams.delete("page");
    }
    return url;
  }

  constructor() {
    super();
    
    this.itemsPerPage = parseInt(this.getAttribute("data-items-per-page") || 48);
    this.totalPages = parseInt(this.getAttribute("data-total-pages") || 1);
    this.totalItems = parseInt(this.getAttribute("data-total-items"));

    this.gridSelector = '[data-product-grid]';
    this.itemSelector = "li[data-product-item]";
    
    this.grid = this.querySelector(this.gridSelector);

    this.loadMoreButton = this.querySelector('[data-load-more]');
    this.loadPreviousButton = this.querySelector('[data-load-previous]');

    this.pages = {};
  }

  connectedCallback() {
    const url = new URL(window.location.href);
    const pageParam = parseInt(url.searchParams.get("page"), 10);
    const lastLoaded = !Number.isNaN(pageParam) && pageParam > 0 ? pageParam : 1;

    const itemCount = this.grid?.querySelectorAll(this.itemSelector).length || 0;
    const spansTwoPages = itemCount > this.itemsPerPage;

    if (!Number.isNaN(pageParam) && pageParam > 0) {
      this.firstVisiblePage = spansTwoPages ? pageParam - 1 : pageParam;
    } else {
      this.firstVisiblePage = 1;
    }

    const previousSearch = url.search;
    this.applyPageParam(url, lastLoaded);
    if (url.search !== previousSearch) {
      history.replaceState(null, "", url.toString());
    }

    this.listener();
    this.updateButtons();
    this.syncPaginationUI();
    this.preloadNextPage();
  }

  saveCards() {
    const items = this.grid.querySelectorAll(this.itemSelector);

    if (items.length > 0) {
      this.firstCard = items[0];
      this.lastCard = items[items.length - 1];
    }
  }

  toggleLoader(button, show) {
    if (!button) return;
    button.classList.toggle('loading', show);
    const spinner = button.querySelector('.loading__spinner');
    if (spinner) {
      spinner.classList.toggle('hidden', !show);
    }
  }

  listener() {
    this.loadMoreButton?.addEventListener("click", async (e) => {
      await this.handleLoadMore();
    });
    
    this.loadPreviousButton?.addEventListener("click", async (e) => {
      await this.handleLoadPrevious();
    });

    subscribe("facets-update", () => {
      if (!this.isConnected) return;
      this.pages = {};
      this.updateButtons();
      this.syncPaginationUI();
    });
  }

  async loadPage(page, useCache = true) {
    // Check cache first
    if (useCache && this.pages[page]) {
      // Clone the cached nodes to avoid reusing the same DOM elements
      return this.pages[page].map(node => node.cloneNode(true));
    }
    
    const url = new URL(window.location.href);
    this.applyPageParam(url, page);
    
    const response = await fetch(url);
    const html = new DOMParser().parseFromString(await response.text(), "text/html");
    
    const items = html.querySelectorAll(this.itemSelector);
    
    // Cache the page (clone nodes to avoid DOM reference issues when appending)
    // Store as array of cloned nodes
    this.pages[page] = Array.from(items).map(node => node.cloneNode(true));
    
    // Return the original items (they'll be appended and moved to DOM)
    return items;
  }

  async handleLoadMore() {
    const lastLoaded = this.pagination;
    const nextPage = lastLoaded + 1;
    
    if (nextPage > this.totalPages) return;

    this.toggleLoader(this.loadMoreButton, true);

    try {
      // Use cached page if available, otherwise load it
      const page = await this.loadPage(nextPage);
      
      const shouldDropFirstPage = this.firstVisiblePage < lastLoaded;

      if (shouldDropFirstPage) {
        const items = this.grid.querySelectorAll(this.itemSelector);
        for (let i = 0; i < this.itemsPerPage && i < items.length; i++) {
          items[i].remove();
        }
        this.firstVisiblePage++;
      }

      this.grid.append(...page);

      if (shouldDropFirstPage) {
        this.lastCard?.scrollIntoView({ behavior: 'instant', block: 'start' });
      }

      const url = new URL(window.location.href);
      this.applyPageParam(url, nextPage);
      history.pushState(null, "", url.toString());

      
      this.updateProductCount(nextPage);
      this.updateButtons();
      this.syncPaginationUI();

      this.saveCards();
      
      // Preload the following page after loading current page
      this.preloadNextPage();
    } catch (err) {
      console.error("Error loading more:", err);
    } finally {
      this.toggleLoader(this.loadMoreButton, false);
    }
  }
  
  async handleLoadPrevious() {
    // Load the page that is one less than the first visible page
    const prevPage = this.firstVisiblePage - 1;
    
    if (prevPage < 1) return;

    this.toggleLoader(this.loadPreviousButton, true);

    try {
      const page = await this.loadPage(prevPage);
      
      const items = this.grid.querySelectorAll(this.itemSelector);
      const startIndex = Math.max(0, items.length - this.itemsPerPage);
      for (let i = startIndex; i < items.length; i++) {
        items[i].remove();
      }
      
      this.grid.prepend(...page);
      
      // Update first visible page since we just prepended a page before it
      this.firstVisiblePage = prevPage;

      this.firstCard?.scrollIntoView({ behavior: 'instant', block: 'start' });
      
      const newLastPage = this.pagination - 1;
      const url = new URL(window.location.href);
      this.applyPageParam(url, newLastPage);
      history.pushState(null, "", url.toString());
      
      this.updateProductCount(newLastPage);
      this.updateButtons();
      this.syncPaginationUI();
      
      this.saveCards();
    } catch (err) {
      console.error("Error loading previous:", err);
    } finally {
      this.toggleLoader(this.loadPreviousButton, false);
    }
  }

  updateButtons() {
    this.loadPreviousButton?.classList.toggle("tw-hidden", this.firstVisiblePage == 1);
    this.loadMoreButton?.classList.toggle("tw-hidden", this.pagination >= this.totalPages);
  }

  /**
   * Computes page numbers and ellipsis segments for PLP pagination when the current page moves via load more.
   * @param {number} current - Active page (1-based).
   * @param {number} total - Total pages.
   * @param {number} [neighborCount=2] - How many numbered neighbors to keep on each side of the current page.
   * @returns {{ type: 'page', n: number } | { type: 'ellipsis' }}[]
   */
  static buildPaginationPartsList(current, total, neighborCount = 2) {
    if (total < 1) return [];
    const c = Math.min(Math.max(1, current), total);
    if (total <= 9) {
      return Array.from({ length: total }, (_, i) => ({ type: "page", n: i + 1 }));
    }
    const add = new Set([1, total]);
    for (let p = c - neighborCount; p <= c + neighborCount; p++) {
      if (p >= 1 && p <= total) add.add(p);
    }
    const sorted = [...add].sort((a, b) => a - b);
    /** @type {{ type: 'page', n: number } | { type: 'ellipsis' }}[] */
    const parts = [];
    for (let i = 0; i < sorted.length; i++) {
      const p = sorted[i];
      if (i > 0 && p - sorted[i - 1] > 1) parts.push({ type: "ellipsis" });
      parts.push({ type: "page", n: p });
    }
    return parts;
  }

  /**
   * @param {number} pageNum
   * @param {boolean} isCurrent
   * @param {(n: number) => string} hrefForPage
   */
  static createPaginationPageLi(pageNum, isCurrent, hrefForPage) {
    const li = document.createElement("li");
    li.setAttribute("data-pagination-middle", "");
    const a = document.createElement("a");
    a.className = "pagination__item link";
    a.dataset.paginationPage = String(pageNum);
    a.textContent = String(pageNum);
    a.setAttribute("aria-label", `Page ${pageNum}`);
    if (isCurrent) {
      a.classList.add("pagination__item--current", "tw-font-medium");
      a.setAttribute("aria-current", "page");
      a.setAttribute("aria-disabled", "true");
      a.setAttribute("role", "link");
    } else {
      a.setAttribute("href", hrefForPage(pageNum));
    }
    li.appendChild(a);
    return li;
  }

  static createPaginationEllipsisLi() {
    const li = document.createElement("li");
    li.setAttribute("data-pagination-middle", "");
    const span = document.createElement("span");
    span.className = "pagination__item";
    span.textContent = "…";
    li.appendChild(span);
    return li;
  }

  /**
   * Replaces server-rendered middle pagination with a window centered on the current page (load more / previous).
   * @param {HTMLElement} root - `[data-plp-pagination]` wrapper.
   * @param {number} cur
   * @param {number} total
   * @param {(n: number) => string} hrefForPage
   */
  rebuildPaginationMiddle(root, cur, total, hrefForPage) {
    const list = root.querySelector("ul.pagination__list");
    const nextAnchor = root.querySelector("[data-pagination-next]");
    const nextLi = nextAnchor?.closest("li");
    if (!list || !nextLi) return;

    list.querySelectorAll("li[data-pagination-middle]").forEach((li) => li.remove());

    const parts = CollectionGrid.buildPaginationPartsList(cur, total);
    const frag = document.createDocumentFragment();
    for (const part of parts) {
      if (part.type === "ellipsis") {
        frag.appendChild(CollectionGrid.createPaginationEllipsisLi());
      } else {
        frag.appendChild(CollectionGrid.createPaginationPageLi(part.n, part.n === cur, hrefForPage));
      }
    }
    list.insertBefore(frag, nextLi);
  }

  /**
   * Keeps numbered pagination and arrows aligned with the active `page` query after load more / previous.
   */
  syncPaginationUI() {
    const root = this.querySelector("[data-plp-pagination]");
    if (!root) return;

    const cur = this.pagination;
    const total = this.totalPages;
    const anchor = root.getAttribute("data-pagination-anchor") || "";

    const hrefForPage = (pageNum) => {
      const nu = new URL(window.location.href);
      this.applyPageParam(nu, pageNum);
      return `${nu.pathname}${nu.search}${anchor}`;
    };

    if (root.querySelector("li[data-pagination-middle]")) {
      this.rebuildPaginationMiddle(root, cur, total, hrefForPage);
    } else {
      root.querySelectorAll("[data-pagination-page]").forEach((el) => {
        const n = parseInt(el.getAttribute("data-pagination-page"), 10);
        if (Number.isNaN(n)) return;

        if (n === cur) {
          el.classList.add("pagination__item--current", "tw-font-medium");
          el.setAttribute("aria-current", "page");
          el.setAttribute("aria-disabled", "true");
          el.setAttribute("role", "link");
          el.removeAttribute("href");
        } else {
          el.classList.remove("pagination__item--current", "tw-font-medium");
          el.removeAttribute("aria-current");
          el.removeAttribute("aria-disabled");
          el.removeAttribute("role");
          el.setAttribute("href", hrefForPage(n));
        }
      });
    }

    const prev = root.querySelector("[data-pagination-prev]");
    if (prev) {
      if (cur <= 1) {
        prev.removeAttribute("href");
        prev.setAttribute("aria-disabled", "true");
        prev.classList.add("tw-pointer-events-none", "tw-opacity-40");
      } else {
        prev.setAttribute("href", hrefForPage(cur - 1));
        prev.removeAttribute("aria-disabled");
        prev.classList.remove("tw-pointer-events-none", "tw-opacity-40");
      }
    }

    const next = root.querySelector("[data-pagination-next]");
    if (next) {
      if (cur >= total) {
        next.removeAttribute("href");
        next.setAttribute("aria-disabled", "true");
        next.classList.add("tw-pointer-events-none", "tw-opacity-40");
      } else {
        next.setAttribute("href", hrefForPage(cur + 1));
        next.removeAttribute("aria-disabled");
        next.classList.remove("tw-pointer-events-none", "tw-opacity-40");
      }
    }
  }

  updateProductCount(page) {
    const totalProducts = page * this.itemsPerPage;
    const totalItems = parseInt(this.getAttribute("data-total-items"));
    
    const currentTotalEl = this.querySelector("[data-current-total-products]");
    if (currentTotalEl) {
      currentTotalEl.innerHTML = Math.min(totalProducts, totalItems);
    }
    
    const sliderEl = this.querySelector('[data-slider]');
    if (sliderEl) {
      sliderEl.style.width = `${(Math.min(totalProducts, totalItems) / totalItems) * 100}%`;
    }
    
    document.querySelectorAll('[data-total-products]').forEach((node) => {
      node.innerHTML = Math.min(totalProducts, totalItems);
    });
  }

  async preloadNextPage() {
    const currentPage = this.pagination;
    const nextPage = currentPage + 1;
    
    // Only preload if next page exists and isn't already cached
    if (nextPage <= this.totalPages && !this.pages[nextPage]) {
      // Preload in background without blocking
      this.loadPage(nextPage, false).catch(err => {
        console.error("Error preloading next page:", err);
      });
    }
  }

  async handleCurrentPagination() {
    const currentPage = this.pagination;
    
    if (currentPage > 1) {
      this.parentElement?.toggleAttribute("loading", true);
      
      try {
        await this.loadPage(currentPage);
        
        if (currentPage + 1 <= this.totalPages) {
          await this.loadPage(currentPage + 1);
        }
      } catch (err) {
        console.error("Error loading pages:", err);
      } finally {
        this.parentElement?.toggleAttribute("loading", false);
      }
    }
    
    this.updateButtons();
  }
}

customElements.define("collection-grid", CollectionGrid);

class CollectionFooter extends HTMLElement {
  constructor() {
    super();

    this.loadMore = this.querySelector('[data-load-more]');
    this.loadLess = this.querySelector('[data-show-less]');
  }

  connectedCallback() {
    if (!this.loadMore) return;

    this.loadMore.addEventListener('click', () => {
      this.toggleAttribute('data-show-all', true);
    });

    this.loadLess.addEventListener('click', () => {
      this.toggleAttribute('data-show-all', false);
    });
  }
}
customElements.define('collection-footer', CollectionFooter);

class SearchProductCard extends HTMLElement {
  
  constructor() {
    super();

    this.handle = this.dataset.handle;
  }

  static resolvePosition(hit, productIndex, page = 0, hitsPerPage = 20) {
    return hit.__position ?? (page * hitsPerPage + productIndex + 1);
  }

  static from(product, queryID, options = {}) {
    const {
      page = 0,
      hitsPerPage = 20,
      index = '',
      productIndex = 0,
    } = options;

    const {
      title,
      vendor,
      handle,
      image,
      id,
      tags,
      objectID,
    } = product;

    const position = SearchProductCard.resolvePosition(product, productIndex, page, hitsPerPage);
    const algoliaObjectId = objectID || id;
    const algoliaIndex = index || new AlgoliaUtils().getIndexName();

    const getMarketPricing = (product) => {
      const marketKey = Object.keys(product).find(key => key.startsWith('market_pricing_'));
      if (marketKey) return product[marketKey].price;

      return product.price;
    };

    const price = getMarketPricing(product);

    const gender = product.meta.elastick.genderweb;
    const designerCollection = `${Shopify.routes.root}collections/designer-${vendor.toLowerCase().replace(/\s+/g, '-')}-${gender}`;
  
    const formatPrice = Shopify.formatMoney(price * 100, Antonioli.settings.currency + '{{amount_no_decimals_with_comma_separator}}');

    const url = `${Shopify.routes.root}products/${handle}`;

    const html = `
      <search-product-card
        data-handle="${handle}"
        data-query-id="${queryID || ''}"
        data-position="${position}"
        data-object-id="${algoliaObjectId}"
        data-product-id="${id}"
        data-index="${algoliaIndex}">
        <div class="card-wrapper tw-group/card product-card-wrapper underline-links-hover">
          <div class="card card--standard card--media" style="--ratio-percent: 149.99925000374998%;">
            <div class="card__inner color-background-1 gradient ratio" style="--ratio-percent: 149.99925000374998%;">
              <div class="card__media">
                <div class="media media--transparent media--hover-effect">
                  <a href="${url}" class="media media--transparent media--hover-effect">
                    <img 
                      srcset="${[165, 360, 533, 720, 940, 1066, 1500].map(w => `${image}?width=${w} ${w}w`).join(', ')}"
                      src="${image}?width=1066"
                      alt="${title}"
                      class="motion-reduce tw-aspect-[1500/2250]"
                      loading="lazy">
                  </a>
                </div>
              </div>
              <div class="card__content">
                <div class="card__information">
                  <h3 class="card__heading">
                    <a href="${url}"
                       id="StandardCardNoMediaLink-${id}" 
                       class="full-unstyled-link tw-capitalize" 
                       aria-label="${title}">
                      ${title}
                    </a>
                  </h3>
                </div>
                <div class="card__badge">
                </div>
              </div>
            </div>
          </div>
          <div class="card__content tw-pt-0 lg:tw-p-4 lg:group-[.grid--8-col-desktop]/pgrid:tw-hidden">
            <div class="card__information">
              <h3 class="card__heading tw-h3-bol tw-p-0">
                <a href="${designerCollection}" class="full-unstyled-link tw-uppercase">
                  ${vendor}
                </a>
              </h3>
              <div class="card-information [&_*]:tw-leading-none">
                <div class="tw-h3-reg tw-capitalize">${title}</div>
                <span class="caption-large light"></span>
                <div data-la-dn-price class="price">
                  <div class="price__container">
                    <div class="price__regular">
                      <span class="price-item price-item--regular tw-h3-bol tw-p-0">
                        ${formatPrice}
                      </span>
                    </div>
                  </div>
                </div>
                <div data-variants class="tw-block tw-relative tw-min-h-[2.2rem]">
                </div>
              </div>
            </div>
          </div>
        </div>
      </search-product-card>
    `;
  
    return html;
  }

  connectedCallback() {
    this.setListeners();
    this.update();
  }

  setListeners() {
    this.addEventListener('click', (event) => {
      event.preventDefault();

      AlgoliaInsights.trackSearchClick({
        queryID: this.dataset.queryId,
        objectID: this.dataset.objectId,
        position: Number(this.dataset.position),
        index: this.dataset.index || new AlgoliaUtils().getIndexName(),
        productId: this.dataset.productId,
      });

      window.location.href = Shopify.routes.root + 'products/' + this.handle;
    })
  }

  async fetch() {
    const url = Shopify.routes.root + 'products/' + this.handle + '?view=card';
    if (sessionStorage.getItem(url) !== null) return sessionStorage.getItem(url);

    const response = await fetch(url);
    const result = await response.text();
    sessionStorage.setItem(url, result);
    return result;
  }

  async update() {
    const html = new DOMParser().parseFromString((await this.fetch()), 'text/html');
    
    this.querySelector('.card-information').innerHTML = html.querySelector('.card-information').innerHTML;
    this.querySelector('.card__badge').outerHTML = html.querySelector('.card__badge').outerHTML;
  }

}

customElements.define('search-product-card', SearchProductCard);


class AntonioliTeaserPopup extends HTMLElement {
  constructor() {
    super();
    this.cookieName = 'antonioliTeaserSuppressed';
    this.cookieMaxAge = 604800;
    this.defaultShowDelay = Math.max(0, parseInt(this.getAttribute('data-teaser-show-after') || '0', 10));
  }

  connectedCallback() {
    if (this._antonioliTeaserBound) return;
    if (Shopify.designMode) return;
    this._antonioliTeaserBound = true;

    this.hidePopup = this.hidePopup.bind(this);
    this.onHostClickCapture = this.onHostClickCapture.bind(this);
    this.handleEscape = this.handleEscape.bind(this);
    this.onDocOpenClick = this.onDocOpenClick.bind(this);

    this.addEventListener('click', this.onHostClickCapture, true);
    document.addEventListener('keydown', this.handleEscape);
    document.addEventListener('click', this.onDocOpenClick);

    const emailEl = this.querySelector('[data-teaser-email]');
    if (emailEl) {
      emailEl.addEventListener('input', () => this._clearEmailError(emailEl));
    }

    this.isSuccessVariant = this.getAttribute('data-teaser-variant') === 'success';
    if (this.isSuccessVariant) {
      const ah = parseInt(this.getAttribute('data-teaser-autohide') || '0', 10);
      if (!Number.isNaN(ah) && ah > 0) {
        this._teaserAutohideId = window.setTimeout(this.hidePopup, ah);
      }
    } else {
      this._scheduleAutoshow();
    }
  }

  disconnectedCallback() {
    this._antonioliTeaserBound = false;
    if (this._teaserShowAfterTimeoutId) {
      window.clearTimeout(this._teaserShowAfterTimeoutId);
      this._teaserShowAfterTimeoutId = 0;
    }
    if (this._teaserAutohideId) {
      window.clearTimeout(this._teaserAutohideId);
      this._teaserAutohideId = 0;
    }
    this.removeEventListener('click', this.onHostClickCapture, true);
    document.removeEventListener('keydown', this.handleEscape);
    document.removeEventListener('click', this.onDocOpenClick);
  }

  /**
   * Open this popup when an external trigger
   * `[data-teaser-open="<this id>"]` is clicked (explicit user action:
   * bypasses the show delay and the suppression cookie).
   * @param {MouseEvent} event
   */
  onDocOpenClick(event) {
    const raw = event.target;
    if (!raw) return;
    const el = raw instanceof Element ? raw : /** @type {Node} */ (raw).parentElement;
    if (!el || !el.closest) return;
    const trigger = el.closest('[data-teaser-open]');
    if (!trigger) return;
    if (trigger.getAttribute('data-teaser-open') !== this.id) return;
    if (this.hideNewsletterPopup()) return;
    event.preventDefault();
    if (this._teaserShowAfterTimeoutId) {
      window.clearTimeout(this._teaserShowAfterTimeoutId);
      this._teaserShowAfterTimeoutId = 0;
    }
    this.classList.remove('is-hidden');
  }

  isTeaserSuppressed() {
    return document.cookie.split(';').some((item) => {
      return item.trim().indexOf(this.cookieName + '=') === 0;
    });
  }

  setTeaserSuppressionCookie() {
    const secure = window.location && window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie =
      encodeURIComponent(this.cookieName) +
      '=1; max-age=' +
      String(this.cookieMaxAge) +
      '; path=/; SameSite=Lax' +
      secure;
  }

  /**
   * Reveal after delay unless the suppression cookie (`this.cookieName`) is set. Uses `data-teaser-show-after` (ms) or `this.defaultShowDelay`.
   */
  _scheduleAutoshow() {
    const attr = this.getAttribute('data-teaser-show-after');
    if (attr != null) {
      const t = String(attr).trim();
      if (t === '0' || t === 'false') return;
    }
    const parsed = attr != null && String(attr).trim() !== '' ? parseInt(String(attr), 10) : NaN;
    const d = !Number.isNaN(parsed) && parsed >= 0 ? parsed : this.defaultShowDelay;
    if (d === 0) return;
    if (this.isTeaserSuppressed()) return;
    this._teaserShowAfterTimeoutId = window.setTimeout(() => {
      this._teaserShowAfterTimeoutId = 0;
      if (this.isTeaserSuppressed()) return;
      if (this.hideNewsletterPopup()) return;
      this.classList.remove('is-hidden');
    }, d);
  }

  hideNewsletterPopup() {
    return this.getAttribute('data-teaser-variant') === 'newsletter' &&
      (document.querySelector('cart-drawer.active') ||
       document.querySelector('#cart-notification.active'));
  }

  /**
   * Append `email` query param to a (possibly relative) base URL,
   * preserving any existing query string and hash.
   * @param {string} base
   * @param {string} email
   * @returns {string}
   */
  _buildRedirectUrl(base, email) {
    let hash = '';
    let url = base;
    const hashIdx = url.indexOf('#');
    if (hashIdx !== -1) {
      hash = url.slice(hashIdx);
      url = url.slice(0, hashIdx);
    }
    const sep = url.indexOf('?') === -1 ? '?' : '&';
    return url + sep + 'email=' + encodeURIComponent(email) + hash;
  }

  /**
   * @param {string} email
   * @returns {boolean}
   */
  _isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  /** Show the inline email validation error and focus the input. */
  _showEmailError(emailEl) {
    emailEl.classList.add('newsletter-teaser-popup__field--error');
    emailEl.setAttribute('aria-invalid', 'true');
    const err = this.querySelector('[data-teaser-email-error]');
    if (err) err.classList.add('is-visible');
    emailEl.focus();
  }

  /** Hide the inline email validation error. */
  _clearEmailError(emailEl) {
    emailEl.classList.remove('newsletter-teaser-popup__field--error');
    emailEl.removeAttribute('aria-invalid');
    const err = this.querySelector('[data-teaser-email-error]');
    if (err) err.classList.remove('is-visible');
  }

  /**
   * Click capture: [data-teaser-close], CTA, or backdrop (outside the panel). Handles TextNode targets.
   * @param {MouseEvent} event
   */
  onHostClickCapture(event) {
    if (this.classList.contains('is-hidden')) return;
    const raw = event.target;
    if (!raw) return;
    const el =
      raw instanceof Element ? raw : /** @type {Node} */ (raw).parentElement;
    if (!el) return;

    if (el.closest && el.closest('[data-teaser-close]')) {
      event.preventDefault();
      this.hidePopup();
      return;
    }
    if (el.closest && el.closest('[data-teaser-cta]')) {
      const redirectUrl = (this.getAttribute('data-teaser-redirect-url') || '').trim();
      if (redirectUrl) {
        event.preventDefault();
        const emailEl = this.querySelector('[data-teaser-email]');
        if (emailEl) {
          const email = String(emailEl.value || '').trim();
          if (!this._isValidEmail(email)) {
            this._showEmailError(emailEl);
            return;
          }
          this._clearEmailError(emailEl);
          this.setTeaserSuppressionCookie();
          window.location.assign(this._buildRedirectUrl(redirectUrl, email));
          return;
        }
        this.setTeaserSuppressionCookie();
        window.location.assign(redirectUrl);
        return;
      }
      this.hidePopup();
      return;
    }
    const panel = this.querySelector('.newsletter-teaser-popup__panel');
    if (panel && !panel.contains(/** @type {Node} */ (raw))) {
      this.hidePopup();
    }
  }

  /** Hides the layer and sets the do-not-show cookie (max-age: `this.cookieMaxAge`). */
  hidePopup() {
    this.classList.add('is-hidden');
    if (this._teaserAutohideId) {
      window.clearTimeout(this._teaserAutohideId);
      this._teaserAutohideId = 0;
    }
    if (!this.isSuccessVariant) this.setTeaserSuppressionCookie();
  }

  /**
   * @param {KeyboardEvent} event
   */
  handleEscape(event) {
    if (event.key === 'Escape' && !this.classList.contains('is-hidden')) this.hidePopup();
  }
}

customElements.define('antonioli-teaser-popup', AntonioliTeaserPopup);